import React from 'react';
import './HowToPlayModal.css';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenTerms?: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose, onOpenTerms }) => {
  if (!isOpen) return null;

  return (
    <div className="how-to-play-overlay" onClick={onClose}>
      <div className="how-to-play-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>

        <h2>About Snap Pairs</h2>

        <div className="modal-section">
          <p style={{ textAlign: 'center', fontSize: '1.1em', lineHeight: '1.6' }}>
            This app was created in honor of <strong>Aimee Rush</strong>, who loves puzzles, for her birthday.
          </p>
          <p style={{ textAlign: 'center', fontSize: '1.3em', marginTop: '1em' }}>
            🎉 <strong>Happy Birthday Aimee!</strong> 🎉
          </p>
          <p style={{ textAlign: 'center', fontSize: '0.9em', marginTop: '2em', color: '#888' }}>
            Copyright 2025, SnapPairs, LLC
          </p>
          {onOpenTerms && (
            <p style={{ textAlign: 'center', marginTop: '1em' }}>
              <button
                onClick={() => { onClose(); onOpenTerms(); }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4a90e2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '0.9em',
                  padding: 0
                }}
              >
                Terms of Service
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
